
import { hideDialog, refresher, showDialog } from "../../../redux/guest-slices/other.slice";
import { useDispatch, useSelector } from "react-redux";
import Icons from "../../../assets/js/Icons";

import {
    APPOINTMENT_CANCEL_CONFIRM,
    APPOINTMENT_SCHEDULE,
} from "../../../utils/keywords";

import {
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Paper,
    Typography,
} from "@mui/material";

import { handleLockSlot, handleConfirmBooking } from "../../../redux/member-slices/appointment.slice";
import { handleCreateAppointment, handleRescheduleAppointment } from "../../../redux/specialist-slices/appointments.slice";
import { useNavigate } from "react-router-dom";
import { checkUserType } from "../../../utils/helper";

function Appointment() {
    const usertype = checkUserType();
    const dispatch = useDispatch();
    const { type, data } = useSelector((state) => state.otherSlice);
    const navigate = useNavigate()

    const handleClose = () => {
        dispatch(hideDialog());
    };


    // const handleAppointment = () => {
    //     if (type !== APPOINTMENT_SCHEDULE) return;
    //     if (usertype === "specialist") {
    //         dispatch(handleCreateAppointment(data))
    //             .unwrap()
    //             .then(() => {
    //                 handleClose();
    //                 dispatch(refresher());
    //             });
    //     } else {
    //         dispatch(handleLockSlot(data))
    //             .unwrap()
    //             .then((res) => {
    //                 const lockData = res?.data || res;
    //                 const confirmPayload = {
    //                     lockId: lockData.lockId || lockData._id,
    //                     specialistId: data.specialistId,
    //                     memberId: data.memberId,
    //                     timezone: data.timeZone,
    //                     notes: data.notes,
    //                     termsAccepted: true,
    //                 };
    //                 return dispatch(handleConfirmBooking(confirmPayload)).unwrap();
    //             })
    //             .then(() => {
    //                 handleClose();
    //                 navigate('/member/profile/appointment/upcoming');
    //                 dispatch(refresher());
    //             })
    //             .catch((err) => {
    //                 console.error("Booking Error:", err);
    //                 // The error toast is handled by the asyncThunkWrapper
    //             });
    //     }


    // }
    const handleAppointment = () => {
        if (type !== APPOINTMENT_SCHEDULE) return;

        // ─────────────────────────────────────
        // SPECIALIST FLOW
        // ─────────────────────────────────────
        if (usertype === "specialist") {
            dispatch(handleCreateAppointment(data))
                .unwrap()
                .then(() => {
                    handleClose();
                    dispatch(refresher());
                });

            return;
        }

        // ─────────────────────────────────────
        // MEMBER RESCHEDULE FLOW
        // ─────────────────────────────────────
        if (data?.mode === "reschedule") {

            dispatch(handleLockSlot(data))
                .unwrap()
                .then((res) => {

                    const lockData = res?.data || res;

                    const payload = {
                        appointmentId: data.appointmentId,
                        lockId: lockData.lockId || lockData._id,
                        timezone: data.timeZone,
                    };

                    return dispatch(handleRescheduleAppointment(payload)).unwrap();
                })
                .then((res) => {
                    if (res?.data?.requiresCancellation) {

                        dispatch(
                            showDialog(
                                APPOINTMENT_CANCEL_CONFIRM,
                                {
                                    appointmentId:
                                        res.data.appointmentId,
                                    hoursBeforeAppointment:
                                        res.data.hoursBeforeAppointment,
                                }
                            )
                        );

                        return;
                    }

                    handleClose();
                    navigate(
                        "/member/profile/appointment/upcoming"
                    );
                    dispatch(refresher());
                })
                .catch((err) => {
                    console.error("Reschedule Error:", err);
                });

            return;
        }

        // ─────────────────────────────────────
        // NORMAL BOOKING FLOW
        // ─────────────────────────────────────
        dispatch(handleLockSlot(data))
            .unwrap()
            .then((res) => {
                const lockData = res?.data || res;

                const confirmPayload = {
                    lockId: lockData.lockId || lockData._id,
                    specialistId: data.specialistId,
                    memberId: data.memberId,
                    timezone: data.timeZone,
                    notes: data.notes,
                    termsAccepted: true,
                };

                return dispatch(handleConfirmBooking(confirmPayload)).unwrap();
            })
            .then(() => {
                handleClose();
                navigate('/member/profile/appointment/upcoming');
                dispatch(refresher());
            })
            .catch((err) => {
                console.error("Booking Error:", err);
            });
    };

    return (
        <Paper>
            <DialogTitle sx={{ position: "relative" }}>
                <Typography
                    sx={{
                        m: "0",
                        fontSize: "24px",
                        fontWeight: "600",
                        textAlign: "center",
                    }}
                >
                    Reschedule Appointment
                </Typography>
                <IconButton
                    sx={{
                        top: "10px",
                        right: "10px",
                        color: "other.color1",
                        position: "absolute",
                    }}
                    size="small"
                    onClick={handleClose}
                >
                    <Icons.Cross />
                </IconButton>
            </DialogTitle>
            <DialogContent
                className="relative"
                sx={{
                    ".MuiInputBase-root": { borderRadius: "6px" },
                }}
            >
                <Typography
                    sx={{
                        m: "0",
                        color: "#333333",
                        fontSize: "16px",
                        fontWeight: "500",
                        textAlign: "center",
                        fontFamily: "Poppins",
                    }}
                >
                    {type === APPOINTMENT_SCHEDULE
                        ? "Are you sure you want to proceed with Reschedule this appointment?"
                        : null}
                </Typography>
            </DialogContent>
            <DialogActions sx={{ justifyContent: "center" }}>
                <Button
                    color="error"
                    variant="contained"
                    sx={{ minWidth: 120 }}

                    onClick={handleClose}
                >
                    Cancel
                </Button>   <Button
                    color="info"
                    variant="contained"
                    sx={{ minWidth: 120 }}

                    onClick={handleAppointment}
                >
                    OK
                </Button>
            </DialogActions>
        </Paper>
    );
}

export default Appointment;
